module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ons-page', {
    staticClass: "l-content"
  }, [_c('custom-toolbar', {
    attrs: {
      "backLabel": "Retour"
    }
  }, [_vm._v(_vm._s(_vm.$t("Mes livraisons")))]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(_vm.shippings) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.$t("Date prévue")))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.$t("Statut")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.shippings), function(shipping, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(shipping.sav_name))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(shipping.sav_date !== null ? _vm.moment(shipping.sav_date).format('DD/MM/YYYY') : 'NC'))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('i', {
      staticClass: "fas",
      class: [shipping.sav_fk_taskStatus == 3 || _vm.moment().format() > _vm.moment(shipping.sav_date).format() ? 'fa-check' : 'fa-times']
    })])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.shippings) ? _c('div', [_vm._v("\n      " + _vm._s(_vm.$t("Pas encore de livraison")) + "\n    ")]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-485c0d1e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Shippings.vue
// module id = 201
// module chunks = 0